<template>
  <div id="app">
    <oomurHeader></oomurHeader>
      <router-view></router-view>
    <oomurFooter></oomurFooter>
  </div>
</template>

<script>
import oomurFooter from '@/components/footer'
import oomurHeader from '@/components/header'
import * as store_token from '@/services/store_token.js'
import store from '@/store/store.js'

export default {
  name: 'App',
  beforeMount(){
    this.$store.dispatch('refresh_token')
  },
    computed: {
      isLoggedIn: function () {
        return this.$store.getters.isLoggedIn
      }
    },
  components: {
    oomurFooter,
    oomurHeader,
  },
  created: function (){
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch('logout')
        }
        throw err
      })
    })
  },
  methods : {
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('login')
      })
    }
  }
}
</script>

<style scoped>
#app{
  width:100%;
  height:100%;
  position:fixed;
  left:0;
  top:0;
  overflow:hidden;
}

</style>



// WEBPACK FOOTER //
// src/App.vue